import { ReactComponent as Chat } from '@assets/icons/ic-chat.svg';
import { ReactComponent as Dashboard } from '@assets/icons/ic-dashboard.svg';
import { ReactComponent as Badge } from '@assets/icons/ic-label.svg';
import { ReactComponent as Banking } from '@assets/icons/ic-banking.svg';
import { ReactComponent as User } from '@assets/icons/ic-user.svg';
import { PATHS } from '@routes/paths';

const ICONS = {
  vote: <Chat />,
  dashboard: <Dashboard />,
  badge: <Badge />,
  point: <Banking />,
  user: <User />,
};

export const sideConfig = [
  {
    subheader: 'management',
    items: [
      {
        title: '대시보드',
        path: PATHS.main,
        icon: ICONS.dashboard,
      },
      {
        title: '배지',
        path: PATHS.badge.index,
        icon: ICONS.badge,
        children: [
          { title: '배지 관리', path: PATHS.badge.list },
          { title: '발급 관리', path: PATHS.badge.setting },
        ],
      },
      {
        title: '포인트',
        path: PATHS.point.list,
        icon: ICONS.point,
      },
      {
        title: '투표',
        path: PATHS.vote.list,
        subPath: PATHS.vote.detail,
        icon: ICONS.vote,
      },
      {
        title: '사용자 관리',
        path: PATHS.user.list,
        subPath: PATHS.user.detail,
        icon: ICONS.user,
      },
    ],
  },
];

export const MiniSidebarWidth = '88px';
export const DefaultSidebarWidth = '304px';
